import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Global from '../../../store/global-selectors';

import { emptyArray } from 'ui-components/default-props/empty';
import TagsColumns from '../../../components/columns/tags-column';
import { messages } from './messages';

const TagsColumn = ({ fulfillmentPlanId }) => {
  const tagIds = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanProperty(state, {
      fulfillmentPlanId,
      property: 'tagIds',
    }),
  );

  return <TagsColumns tagIds={tagIds ?? emptyArray} />;
};

TagsColumn.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};

export const Tags = {
  getMessageDescriptor: () => messages.tags,
  id: 'tags',

  render: (data, { isExpanded = false, isFirstRow = true } = {}) => {
    if (isExpanded && !isFirstRow) {
      return '';
    }
    return <TagsColumn fulfillmentPlanId={data.id} />;
  },
};
